import PropTypes from "prop-types";
import { connect } from "react-redux";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getRobotsMetaTag } from "app/reducers/partnerSelector";

const SmartDPSearchHeadMetadata = ({ robotsMetaTag, titleFromSanity, descriptionFromSanity }) => {
	const title = titleFromSanity || "page.title.sdp.home";
	const description = descriptionFromSanity || "page.description.sdp.home";

	return <HeadMetadata description={description} title={title} robotsMetaTag={robotsMetaTag} />;
};

SmartDPSearchHeadMetadata.propTypes = {
	robotsMetaTag: PropTypes.string,
	titleFromSanity: PropTypes.string,
	descriptionFromSanity: PropTypes.string,
};

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);
	return {
		robotsMetaTag: robotsMetaTag?.sdpSearch,
		titleFromSanity: state.brand?.seo?.sdpHome?.metaTitle,
		descriptionFromSanity: state.brand?.seo?.sdpHome?.metaDescription,
	};
};

export default connect(mapStateToProps)(SmartDPSearchHeadMetadata);
